import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Notice, Skeleton } from "../ui";
import { api, ApiFehler, rufe } from "../api/client";

/**
 * Ein Link darf nur einmal eingelöst werden. React (StrictMode) führt Effekte doppelt aus,
 * deshalb wird je Token genau ein Aufruf gestartet und von beiden Effekten geteilt.
 */
const laufende = new Map<string, Promise<{ ziel: string }>>();

function einloesen(token: string): Promise<{ ziel: string }> {
  let p = laufende.get(token);
  if (!p) {
    p = rufe<{ ziel: string }>(api.api.auth.login.$post({ json: { token } }));
    laufende.set(token, p);
  }
  return p;
}

/** Löst den Link aus der E-Mail ein und leitet in den Zielbereich weiter. */
export function AnmeldenToken() {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    einloesen(token).then(
      (r) => {
        qc.clear();
        navigate(r.ziel || "/", { replace: true });
      },
      (err) => setFehler(err instanceof ApiFehler ? err.message : "Der Link konnte nicht eingelöst werden."),
    );
  }, [token, navigate, qc]);

  return (
    <div className="app-public">
      <div className="app-public__card">
        {fehler ? (
          <Notice tone="attention" title="Der Link funktioniert nicht mehr" action={<Button variant="primary" onClick={() => navigate("/anmelden")}>Neuen Link anfordern</Button>}>
            {fehler}
          </Notice>
        ) : (
          <>
            <p className="sc-muted">Anmeldung läuft …</p>
            <Skeleton lines={2} />
          </>
        )}
      </div>
    </div>
  );
}
